"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Card_exports = {};
__export(Card_exports, {
  Card: () => Card,
  CardBackground: () => CardBackground,
  CardFooter: () => CardFooter,
  CardFrame: () => CardFrame,
  CardHeader: () => CardHeader
});
module.exports = __toCommonJS(Card_exports);
var import_jsx_runtime = (
  // <CardProvider scope={__scopeCard} size={size}>
  require("react/jsx-runtime")
);
var import_stacks = require("@tamagui/stacks");
var import_web = require("@tamagui/web");
var import_react = __toESM(require("react"));
const CardFrame = (0, import_web.styled)(import_stacks.ThemeableStack, {
  name: "Card",
  backgroundColor: "$background",
  position: "relative",
  overflow: "hidden",
  variants: {
    size: {
      "...size": (val, { tokens }) => {
        return {
          borderRadius: tokens.radius[val] ?? val
        };
      }
    }
  },
  defaultVariants: {
    size: "$true"
  }
});
const CardHeader = (0, import_web.styled)(import_stacks.ThemeableStack, {
  name: "CardHeader",
  zIndex: 10,
  backgroundColor: "transparent",
  marginBottom: "auto",
  variants: {
    size: {
      "...size": (val, { tokens }) => {
        return {
          padding: tokens.space[val] ?? val
        };
      }
    }
  }
});
const CardFooter = (0, import_web.styled)(CardHeader, {
  name: "CardFooter",
  zIndex: 5,
  flexDirection: "row",
  marginTop: "auto",
  marginBottom: 0
});
const CardBackground = (0, import_web.styled)(import_stacks.ThemeableStack, {
  name: "CardBackground",
  zIndex: 0,
  fullscreen: true,
  overflow: "hidden",
  pointerEvents: "none",
  padding: 0
});
const Card = (0, import_web.withStaticProperties)(
  CardFrame.extractable(
    (0, import_react.forwardRef)(
      ({ size, __scopeCard, children, ...props }, ref) => {
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CardFrame, { ref, ...props, children: import_react.default.Children.map(children, (child) => {
          if ((0, import_web.isTamaguiElement)(child) && !child.props.size) {
            return (0, import_react.cloneElement)(child, {
              size
            });
          }
          return child;
        }) });
      }
    )
  ),
  {
    Header: CardHeader,
    Footer: CardFooter,
    Background: CardBackground
  }
);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Card,
  CardBackground,
  CardFooter,
  CardFrame,
  CardHeader
});
//# sourceMappingURL=Card.js.map
